//chapter1
export default {
    id : 18,//chapter number
    title : '18. PFMEA 작성방법 (5) - PFMEA 고장분석',//chapter name
    slides : [
        {
            title : 'Intro',
            type : 'intro',
            source : 'c18.mp4',
        },
        {
            title : 'Today’s Goal',
            type : 'plan',
            body1 : [
                'PFMEA 고장분석',
            ],
            body2 : [
                'PFMEA 고장분석에 대해 설명할 수 있다.'
            ],
            bgm : "plan.mp3"
        },
        {
            title : 'Lesson',
            type : 'lesson',
            source : '18.mp4',
        },
        {
            title : 'Quiz',
            type : 'quiz',
            quiz : [
                {
                    type : 'ox',
                    question : '공정의 고장형태는 공정기능으로부터 정의된다.',//html available
                    answer : "1",
                    explain : '공정기능의 손상이 고장형태가 된다.'
                },
                {
                    type : 'ox',
                    question : '공정 FMEA 분석에 입고되는 모든 자재(부품)는 정상이라고 정의한다.',//html available
                    answer : "1",
                    explain : '공정의 관리는 모든 부품이 정상일 때의 조건으로 관리된다.'
                },
            ],
            quizMask : "../assets/images/quiz_intro.jpg",//quiz mask
            bgm : "quiz.mp3"
        },
        {
            title : 'Summary',
            type : 'summary',
            /*download : 'sample.pptx',//data folder*/
            print : false,// true : show, false: hide
            slides : [
                {
                    body : `<ul>
                        <h3>1. 고장의 이해와 분류</h3>
                        <li>고장분석의 목적은 고장형태, 원인, 영향을 규정하고 그들의 관계를 보여주는 것</li>
                        <li>Failure : 공정 steps의 고장은 공정과 제품 특성으로부터 추론됨</li>
                        <p class="mg10"></p>
                        <h3>2. 고장 Chine 이해와 작성방법</h3>
                        <li>고장영향 : 공정 item의 기능과 관계가 있음</li>
                        <li>고장형태 : 설계의도 및 공정요구사항을 잠재적으로 충족시키지 못하는 작업의 부적합</li>
                        <li>고장원인 : 고장원인의 결과는 고장형태임</li>
                        <p class="mg10"></p>
                        <h3>3. 양식 사용방법</h3>
                    </ul>`
                },
            ],
            bgm : "summary.mp3"
        },
        {
            title : 'Outro',
            type : 'outro',
            source : 'c18.mp4',
        },
    ]
}